import React from "react"

import type { Organization } from "@/models/organization"
import { DataGridToolbar } from "@/nzds/data-grid"
import { MonthRangePicker } from "@/nzds/inputs/month-range-picker"
import type { Interval } from "luxon"

import type { GridSlots, PropsFromSlot } from "@mui/x-data-grid-pro"

import { SitesExportCsvMenuItem } from "../../components/sites-export-csv-menu-item"

export interface SitesOverviewGridToolbarProps extends PropsFromSlot<
  GridSlots["toolbar"]
> {
  availableMaxMinMonths: Interval | undefined
  dateRange: Interval | undefined
  onDateRangeChange: (value: Interval | null) => void
  organizationId?: Organization["id"]
}

export const SitesOverviewGridToolbar: React.FC<
  SitesOverviewGridToolbarProps
> = ({
  availableMaxMinMonths,
  dateRange,
  onDateRangeChange,
  organizationId,
}) => {
  return (
    <DataGridToolbar
      moreMenuItems={
        <div>
          {
            // Cannot wrap in fragment (e.g. <></>) due to MUI error
            // https://github.com/mui/material-ui/issues/16181
          }
          <SitesExportCsvMenuItem
            endDate={dateRange?.end?.toISODate()}
            organizationId={organizationId}
            startDate={dateRange?.start?.toISODate()}
          />
        </div>
      }
      showColumnSelector
      startActions={
        <MonthRangePicker
          availableMaxMinMonths={availableMaxMinMonths}
          onChange={onDateRangeChange}
          value={dateRange}
        />
      }
    />
  )
}
